import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "@environments/environment";
import { environmentProductos } from "@environments/environment";
import { environmentEmpleados } from "@environments/environment";
import { map } from "rxjs/operators"; //mapeo de respuesta de base de datos.

import { User, Proveedor } from "@app/_models";
import { stringify } from "querystring";

@Injectable({ providedIn: "root" })
export class UserService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<User[]>(`${environment.apiUrl}/USER/Get`);
  }

  // PARTICIPANTES

  postParticipantes(user: User) {
    return this.http.post<User>(
      `${environment.apiUrl}/USER/InsertOrUpdate`,
      user
    );
  }

  getIdParticipantes(id) {
    return this.http.get(`${environment.apiUrl}/USER/GetById?Id=` + id);
  }

  //SELECCION DE ALIMENTOS

  getIdCategory(id) {
    return this.http.get(
      `${environmentProductos.apiUrl}/User/GetByID?Id=` + id
    );
  }

  getIdDistribuidor(id) {
    return this.http.get(
      `${environmentProductos.apiUrl}/USER/GetById?Id=` + id
    );
  }

  getIdCategoryManager(id) {
    return this.http.get(
      `${environmentProductos.apiUrl}/USER/GetById?Id=` + id
    );
  }

  postDistribuidor(user: Proveedor) {
    return this.http.post<Proveedor>(
      `${environmentProductos.apiUrl}/USER/InsertOrUpdate`,
      user
    );
  }

  postCategory(user: Proveedor) {
    return this.http.post<Proveedor>(
      `${environmentProductos.apiUrl}/USER/InsertOrUpdateCategory`,
      user
    );
  }

  postCategoryManager(user: User) {
    return this.http.post<User>(
      `${environmentProductos.apiUrl}/UserCategory/InsertOrUpdate`,
      user
    );
  }

  recuperarPassword(user: any) {
    return this.http.post<User>(
      `${environmentProductos.apiUrl}/USER/ChangePassword`,
      user
    );
  }

  deleteUser(id) {
    //console.log("ID EN SERVICE", id);
    return this.http.post<any>(
      `${environmentProductos.apiUrl}/USER/Disabled`,
      id
    );
  }

  //SELECCION DE COMERCIANTES

  //EMPLEADOS

  getCurrentUserInformation() {
    return this.http.get(
      `${environmentEmpleados.apiUrl}/User/CurrentUserInformation`
    );
  }

  getTypeEmploye(typeID) {
    return this.http.get(
      `${environmentEmpleados.apiUrl}/EmploymentType/${typeID}`
    );
  }

  getEmploymentTypes() {
    return this.http.get(`${environmentEmpleados.apiUrl}/EmploymentType/`);
  }

  //get de empleados (aparece como User)
  getEmployee(ID) {
    return this.http.get(`${environmentEmpleados.apiUrl}/User/${ID}`);
  }

  //put de empleados (aparece como User)
  putEmployee(user) {
    let json = JSON.stringify(user);
    return this.http
      .put(`${environmentEmpleados.apiUrl}/User/UpdateCurrentUser`, json)
      .pipe(map((res) => res));
  }
  //Validation date to login
  validateDateToLogin(date) {
    let request = {
      date: date,
    };
    return this.http.post<any>(
      `${environmentProductos.apiUrl}/User/VerifyDateRange`,
      request
    );
  }
}
